<template>
  <header id="masthead" class="site-header">
		<nav class="navbar navbar-expand-lg fixed-top" style="background: transparent;">
			<router-link tag="a" :to="'/' + this.$route.params.lang" @click.native="resetdata" class="navbar-brand" >
				<img src="@/assets/images/logo.png" alt="">
				<span class="logoDash"></span>
				<span class="logoSiteName">{{ $t('logo_site_name') }}</span>
			</router-link>

			<div>
				<div class="localeWrapper " tabindex="0" @focusout="focusOut(); rotateOut()">
					<div class="activeLocale" >
						<div @click="show(); rotate()" >
							<p class="activeLocaleP">{{ activeLocale }}</p>
							<img src="@/assets/images/dropdown-arrow.svg" alt="" class="dropdownArrow" :class="{ rotateArrow: rotateArrow}"  style="display:none">
						</div>
						
						<transition name="slide_dropdown">
						<div class="localeDropdown" v-if="showLocaleDropdown">
							<p v-for="(lang, index) in $i18n.availableLocales" :key="`Lang${index}`" :class="{ activeLocaleClass: activeLocale == lang}" @click.stop="changeLocale(lang)" > 
								{{ lang }} 
							</p>
						</div>
						</transition>
					</div>
				</div>				
				<!-- <a class="support-btn outline collapser" href="mailto:test@test.com" scroll-target="#contactSupport" role="button" aria-expanded="false" aria-controls="contactSupport">{{ $t('contact_support_button') }}</a> -->
			</div>
		</nav>

	</header>
</template>

<script>
import i18n from '@/plugins/i18n';

export default {
	data: () => {
		return {
			showLocaleDropdown: false,
			rotateArrow: false,
		}
	},
	computed: {
		activeLocale: function() {
			return this.$store.state.activeLocale
		}
	},
	watch: {
		'$route.params.lang': function () {
			this.showLocaleDropdown = false,
			this.rotateArrow = false;
		}
	},
	methods: {   
		show()
		{
			this.showLocaleDropdown = !this.showLocaleDropdown;
			
		},
		focusOut() {
			if(this.showLocaleDropdown) {
				this.showLocaleDropdown = !this.showLocaleDropdown;
			}
		},
		rotate() {
			this.rotateArrow =  !this.rotateArrow; 
		},
		rotateOut() {
			if(this.rotateArrow) {
				this.rotateArrow =  !this.rotateArrow; 
			}
			
		},
		changeLocale(locale) {
			if(this.$store.state.activeLocale != locale){
				this.showLocaleDropdown = !this.showLocaleDropdown;
				this.$store.state.activeLocale = locale
				let hash = "";
				// if(this.$route.hash) {
				// 	hash = this.$route.hash;
				// }
				i18n.locale = locale;
				this.$router.push({
					params: { lang: locale},
					hash: hash
				})
			}
			
		},
		resetdata() {
			this.$store.state.showResults = false;
			this.$store.state.activeCategory = null;
		}
		
	}
}
</script>

<style scoped>
	.logoDash {
		margin: 0 15px;
		border-left: 1px solid black;
		height: 15px;
	}
	.logoSiteName {
		font-size: 15px;
		font-weight: 300;
		text-transform: capitalize;
		color: white;
		letter-spacing: 1px;
		line-height: 24px;
	}
	.navbar-brand {
		display: inline-flex;
		align-items: center;
	}
	header nav.navbar .navbar-brand img {
		width: 90px;
	}
	.localeWrapper {
		text-transform: uppercase;
	}
	.localeWrapper:focus {
		outline: none;
	}
	.activeLocale {
		color: white;
		position: relative;
		cursor: pointer
	}
	.dropdownArrow {
		top: 8px;
		left: 27px;
		display: inline-block;
		width: 13px;
		height: auto !important;
		margin-left: 10px !important;
		vertical-align: 0.08em !important;
		border: none;
		-webkit-transition: all .1s;
		transition: all .1s;
	}
	.activeLocaleP {
		display: inline;
	}
	.rotateArrow {
		transform: scale(-1);
	}
	.activeLocale > p {
		margin-bottom: 0;
		font-weight: bold;
		font-size: 16px;
	}
	.localeDropdown {
		position: absolute;
		background: white;
		top: 34px;
		left: -13px;
		max-height: 500px;
		overflow: hidden;
	}
	.localeDropdown > p{
		display: block;
		width: 100%;
		padding: .25rem 1.5rem;
		margin: 0;
		clear: both;
		font-weight: 400;
		color: #212529;
		text-align: inherit;
		white-space: nowrap;
		background-color: transparent;
		border: 0;
		border-bottom: 1px solid #f0f0f0;
	}
	.localeDropdown > p:hover{
		color: white;
		background-color: #444d67;
		border-bottom: 1px solid #444d67;
	}
	.slide_dropdown-enter {
		max-height: 0;
	}
	.slide_dropdown-enter-active {
		transition: all 0.1s ease-in;
	}
	.slide_dropdown-leave {
		
	}
	.slide_dropdown-leave-active {
		transition: all 0.1s ease-in;
		max-height: 0;
	}
	.localeDropdown .activeLocaleClass {
		color: white;
		background-color: #444d67;
		border-bottom: 1px solid #444d67;
	}
	@media (max-width: 576px) {
		header nav.navbar .navbar-brand img {
			width: 60px;
		}
		header nav.navbar .navbar-brand .logoDash {
			font-size: 12px;
			margin: 0 7px;
		}
		header nav.navbar .navbar-brand .logoSiteName {
			font-size: 12px;
		}
		.activeLocale > p {
			font-size: 16px;
		}
		.dropdownArrow {
			top: 8px;
			left: 27px;
			width: 13px;
		}
	}
</style>
